module.exports = __webpack_public_path__ + "img/crotch_height.250e816f.png";